import React, { useEffect, useState } from 'react';

import { Input, InputGroup, InputGroupText, Select } from 'twyne-new.ui';

import Checkbox from './Checkbox';

export default function TemplateGroup({ loadOptions, className, value, onChange, placeholder }) {
  const [enabled, setEnabled] = useState(true)

  useEffect(() => {
    setEnabled(value !== undefined)
  }, [value])

  const handleChangeEnabled = enabled => {
    onChange(enabled ? '' : undefined)
    setEnabled(enabled)
  }

  const handleChange = option => {
    const value = option && option.value || ''
    onChange(value)
  }

  return <InputGroup>
    <InputGroupText addonType='append'>
      <Checkbox
        value={enabled}
        onChange={handleChangeEnabled}
      />
    </InputGroupText>
    {!enabled ? <Input disabled placeholder='disabled' className='italic' /> : <Select
      async
      className={className}
      loadOptions={loadOptions}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
    />}
  </InputGroup>
}

TemplateGroup.defaultProps = {
  className: '',
  placeholder: 'Default',
}
